import Cookies from 'js-cookie';


export default {

    authSuccess: (state, access_token) => {
        state.access_token = access_token;
    },
    authError: (state, err) => {
        /* let errors=err.errors?err.errors:{};
         if(err.error=="invalid_credentials"){
             errors.invalid_credentials=['The user credentials were incorrect.'];
         }

         state.status = 'error';
         state.hasLoadedOnce = true;
         state.errors.record(errors);*/
    },
    authLogout: (state) => {
        // Nome corrigido — era authauthSuccesst (typo). Nunca foi chamada por causa
        // disso; logoutRequest usava commit('authLogout') comentado.
        // Agora logoutRequest chama commit('authSuccess', '') que faz o mesmo,
        // mas esta mutation fica disponível para chamadas explícitas.
        state.access_token = '';
        Cookies.remove('access_token');
        // Sem isso o logout não encerra a sessão: o refresh continuaria válido
        // e o interceptor emitiria um access token novo.
        Cookies.remove('refresh_token');
    }
}